export class PericingCategoryModel {
  public HourlyRate: number;
  public hourlyRateVat: string;
  public MileageRate: number = 0;
  public mileageRateVat: string;
  public FixedFee: number;
  public fixedFeeVat: string;
  public periodRate: number;
  public periodRateVat: string;
}

export class ContractTypeModel {
  public contractTypeHashId: string;
  public contractName: string;
  public contractTypeGroupHashId: string;
  public isChecked: boolean;
  public isHourlyRate: boolean = false;

  public sunFlag: boolean = true;
  public monFlag: boolean = true;
  public tueFlag: boolean = true;
  public wedFlag: boolean = true;
  public thuFlag: boolean = true;
  public friFlag: boolean = true;
  public satFlag: boolean = true;

  public dayStartTime: string;
  public dayEndTime: string;
  public comment: string;

  public contractTypePeriod: string = '';
  public specialPeriodHashID: string = '';
  public contractTypeType: string;

  public extraTimeBefore: number;
  public extraTimeAfter: number;
  public freeTextSpecialPeriod: string = "";

  public periodRate: number = 0;
  public periodRateVat: string = '0';
  public hourlyRate: number = 0;
  public hourlyRateVat: string = '0';
  public mileageRate: number = 0;
  public mileageRateVat: string = '0';
  public fixedFee: number = 0;
  public fixedFeeVat: string = '0';
  public currencySymbol: string;
  public isCurrencySymbolBefore: boolean = true;
  public hourlyRateDisplay: string;
  public periodRateDisplay: string;
  public mileageRateDisplay: string;
  public fixedFeeDisplay: string = '0';
  public vatSettingDefaultCost: boolean = true;
  //public ContractStartDateTime: string;
  public contractEndDateTime: string;
  public modifiedBy: string;

  public catAPricingModel: PericingCategoryModel;
  public catBPricingModel: PericingCategoryModel;
  public catCPricingModel: PericingCategoryModel;
  public catDPricingModel: PericingCategoryModel;
  public catEPricingModel: PericingCategoryModel;
  public catFPricingModel: PericingCategoryModel;
  public catGPricingModel: PericingCategoryModel;
  public catHPricingModel: PericingCategoryModel;

  public isEditable: boolean;
  public isDeletable: boolean;

  constructor() {
    this.catAPricingModel = new PericingCategoryModel();
    this.catBPricingModel = new PericingCategoryModel();
    this.catCPricingModel = new PericingCategoryModel();
    this.catDPricingModel = new PericingCategoryModel();
    this.catEPricingModel = new PericingCategoryModel();
    this.catFPricingModel = new PericingCategoryModel();
    this.catGPricingModel = new PericingCategoryModel();
    this.catHPricingModel = new PericingCategoryModel();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contractType/models/contractType.model.ts